module.exports = __webpack_public_path__ + "static/media/image-38.1fb4db7b.png";